// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import getQuoteDetails from "@bg/App/Handlers/CustomQuote/GetCustomQuote";
import { copyQuoteLines, CopyQuoteLines } from "@bg/App/Services/CustomQuoteService";
import {
    createHandlerChainRunner,
    Handler,
    markSkipOnCompleteIfOnErrorIsSet,
} from "@insite/client-framework/HandlerCreator";

interface Props {
    apiParameter: CopyQuoteLines;
    apiResult: { successful: boolean; error?: any };
}

type Parameter = CopyQuoteLines & {
    customQuoteId: string;
    onSuccess?: () => void;
    onComplete?: (result: any) => void;
    onError?: (e: any) => void;
};

type HandlerType = Handler<Parameter, Props>;

export const BeginLoadingQuotes: HandlerType = props => {
    props.dispatch({
        type: "Pages/MyCustomQuotes/BeginLoadingQuoteDetails",
    } as any);
};

export const DispatchBeginAction: HandlerType = props => {
    props.apiParameter = {
        ...props.parameter,
    };
};

export const CallApiWithParameters: HandlerType = async props => {
    props.apiResult = await copyQuoteLines(props.apiParameter);
};

export const OnError: HandlerType = props => {
    if (!props.apiResult.successful) {
        props.dispatch({
            type: "Pages/MyCustomQuotes/CompleteLoadingQuoteDetails",
        } as any);

        markSkipOnCompleteIfOnErrorIsSet(props);
        props.parameter.onError?.(props.apiResult.error);
    }
};

export const CallOnComplete: HandlerType = props => {
    if (props.apiResult.successful) {
        props.dispatch(
            getQuoteDetails({
                quoteId: props.parameter.customQuoteId,
                onComplete: (result: any) => {
                    if (result.successful) {
                        props.parameter.onComplete?.(props.apiResult);
                    }
                },
            }),
        );
    }
};

export const chain = [BeginLoadingQuotes, DispatchBeginAction, CallApiWithParameters, OnError, CallOnComplete];

const copyLines = createHandlerChainRunner(chain, "CopyLines");
export default copyLines;
